import { createAction } from 'redux-actions';

import { HELP_CENTER_CLICKED } from 'app/features/helpCenter/actionTypes';

const helpCenterClicked = createAction(HELP_CENTER_CLICKED);

export { helpCenterClicked };
